export const EMAIL_FIELD_NAME = 'email'
